import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  content: {
    marginTop: 60,
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
  },
  floatingButton: {
    margin: 0,
    top: 'auto',
    bottom: 20,
    left: 'auto',
    position: 'fixed',
  },
}))

export default styles
